import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
export default {
  __name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: 'submit',
      validator: val => ['submit', 'revoke', 'draft', 'approval', 'cancel', 'import', 'export', 'transfer', 'expedite', 'print', 'delete', 'invoice', 'record', 'download'].includes(val)
    },
    text: {
      type: String,
      default: ''
    },
    circle: {
      type: Boolean,
      default: false
    },
    customColor: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    var props = __props;
    var variantClass = computed(() => {
      var map = {
        submit: 'btn-submit',
        //提交 / 确定/新增
        revoke: 'btn-revoke',
        //撤销/撤销申请
        approval: 'btn-approval',
        //审批
        draft: 'btn-draft',
        // 暂存
        cancel: 'btn-cancel',
        //取消 / 返回/重置
        export: 'btn-export',
        //导入/导出
        transfer: 'btn-transfer',
        //转他人
        expedite: 'btn-expedite',
        //催办
        print: 'btn-print',
        //打印
        delete: 'btn-delete',
        //删除
        invoice: 'btn-invoice',
        //补充发票/补充附件
        record: 'btn-record',
        //导入记录
        download: 'btn-download' //下载
      };
      return map[props.type] || 'btn-default';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        class: _normalizeClass(["base-button", [variantClass.value, {
          'is-circle': __props.circle
        }]]),
        style: _normalizeStyle(__props.customColor ? {
          backgroundColor: __props.customColor
        } : {})
      }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.text), 1)])], 6);
    };
  }
};